exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel .error-message[data-v-a24f665c]{border:2px solid #db4649;border-radius:4px;padding:10px;font-size:14px;background:#f5dedf;margin:10px 0}", ""]);

// exports
